(function () {
var $a64bee6b4e24ceb8$exports = {};
const $a64bee6b4e24ceb8$var$viewPanels = Array.from(document.querySelectorAll("[data-workspace-view-panel]"));
const $a64bee6b4e24ceb8$var$viewLinks = Array.from(document.querySelectorAll("[data-workspace-view-link]"));
const $a64bee6b4e24ceb8$var$tabButtons = Array.from(document.querySelectorAll(".workspace-tab"));
const $a64bee6b4e24ceb8$var$tabPanels = Array.from(document.querySelectorAll("[data-workspace-tab-panel]"));
const $a64bee6b4e24ceb8$var$COMPATIBLE_HASHES = {
    "search-preview": {
        view: "records",
        tab: "preview"
    }
};
const $a64bee6b4e24ceb8$var$state = {
    tab: "catalog",
    view: "overview"
};
function $a64bee6b4e24ceb8$var$syncHistory() {
    const url = new URL(window.location.href);
    url.hash = `#${$a64bee6b4e24ceb8$var$state.view}`;
    if ($a64bee6b4e24ceb8$var$state.view === "records" && $a64bee6b4e24ceb8$var$state.tab !== "catalog") url.searchParams.set("tab", $a64bee6b4e24ceb8$var$state.tab);
    else url.searchParams.delete("tab");
    window.history.replaceState({}, "", url);
}
function $a64bee6b4e24ceb8$var$dispatchWorkspaceChange() {
    window.dispatchEvent(new CustomEvent("workspace:tab-changed", {
        detail: {
            tab: $a64bee6b4e24ceb8$var$state.tab,
            view: $a64bee6b4e24ceb8$var$state.view
        }
    }));
}
function $a64bee6b4e24ceb8$var$activateView(view) {
    $a64bee6b4e24ceb8$var$state.view = view;
    $a64bee6b4e24ceb8$var$viewPanels.forEach((panel)=>{
        panel.hidden = panel.dataset.workspaceViewPanel !== view;
    });
    $a64bee6b4e24ceb8$var$viewLinks.forEach((link)=>{
        link.classList.toggle("is-active", link.dataset.workspaceViewLink === view);
    });
}
function $a64bee6b4e24ceb8$var$activateTab(tab) {
    $a64bee6b4e24ceb8$var$state.tab = tab;
    $a64bee6b4e24ceb8$var$tabButtons.forEach((button)=>{
        const isActive = button.dataset.workspaceTabTarget === tab;
        button.classList.toggle("is-active", isActive);
        button.classList.toggle("button--secondary", isActive);
        button.classList.toggle("button--ghost", !isActive);
    });
    $a64bee6b4e24ceb8$var$tabPanels.forEach((panel)=>{
        panel.hidden = panel.dataset.workspaceTabPanel !== tab;
    });
}
function $a64bee6b4e24ceb8$var$applyState(nextState, options = {}) {
    $a64bee6b4e24ceb8$var$activateView(nextState.view);
    if (nextState.view === "records") $a64bee6b4e24ceb8$var$activateTab(nextState.tab || $a64bee6b4e24ceb8$var$state.tab || "catalog");
    if (!options.skipHistory) $a64bee6b4e24ceb8$var$syncHistory();
    $a64bee6b4e24ceb8$var$dispatchWorkspaceChange();
}
function $a64bee6b4e24ceb8$var$parseLocationState() {
    const url = new URL(window.location.href);
    const hash = url.hash.replace("#", "");
    const compatibleState = $a64bee6b4e24ceb8$var$COMPATIBLE_HASHES[hash];
    if (compatibleState) return compatibleState;
    const recordId = url.searchParams.get("recordId");
    const tab = url.searchParams.get("tab");
    const hasView = $a64bee6b4e24ceb8$var$viewPanels.some((panel)=>panel.dataset.workspaceViewPanel === hash);
    if (recordId) return {
        view: "records",
        tab: tab || "editor"
    };
    if (hash === "records") return {
        view: "records",
        tab: tab || "catalog"
    };
    if (hasView) return {
        view: hash,
        tab: "catalog"
    };
    return {
        view: "overview",
        tab: "catalog"
    };
}
function $a64bee6b4e24ceb8$var$navigate(detail = {}, options = {}) {
    const nextState = {
        tab: detail.tab || $a64bee6b4e24ceb8$var$state.tab || "catalog",
        view: detail.view || $a64bee6b4e24ceb8$var$state.view || "overview"
    };
    $a64bee6b4e24ceb8$var$applyState(nextState, options);
}
document.addEventListener("click", (event)=>{
    const control = event.target.closest("[data-workspace-view-link], [data-workspace-view-target], .workspace-tab");
    if (!control) return;
    event.preventDefault();
    $a64bee6b4e24ceb8$var$navigate({
        tab: control.dataset.workspaceTabTarget || undefined,
        view: control.dataset.workspaceViewLink || control.dataset.workspaceViewTarget || undefined
    });
});
window.addEventListener("workspace:navigate", (event)=>{
    $a64bee6b4e24ceb8$var$navigate(event.detail || {});
});
window.addEventListener("hashchange", ()=>{
    $a64bee6b4e24ceb8$var$applyState($a64bee6b4e24ceb8$var$parseLocationState(), {
        skipHistory: true
    });
});
$a64bee6b4e24ceb8$var$applyState($a64bee6b4e24ceb8$var$parseLocationState(), {
    skipHistory: true
});

})();
//# sourceMappingURL=index.ff18a226.js.map
